import React from 'react';
import CenteredActivityResponseText from '../CenteredActivityResponseText/CenteredActivityResponseText';

function ActResponseCancelDetails() {
  return <CenteredActivityResponseText text="Cette facture a été annulée avec succès" />;
}

export default ActResponseCancelDetails;
